import { Component, OnInit, ViewChild } from '@angular/core'
import {
  EntityGroupProviderODataService,
  IEntityGroupProvider,
  IProvider,
  ProviderODataService
} from '@exchange/domain/.'
import { GridWrapperComponent, MultiRowSelection } from 'common-components'
import { ActivatedRoute } from '@angular/router'
import { forkJoin } from 'rxjs'

@Component({
  selector: 'app-entity-group-edit-providers',
  templateUrl: './entity-group-edit-providers.component.html',
  standalone: false
})
export class EntityGroupEditProvidersComponent implements OnInit {
  @ViewChild('available', { static: true }) available: GridWrapperComponent
  @ViewChild('selected', { static: true }) selected: GridWrapperComponent
  entityGroupId: number = null
  availableSelection: IProvider[] = []
  selectedSelection: IEntityGroupProvider[] = []
  selectedIds: number[] = []
  private _gridOptions = {
    canEdit: false,
    canDelete: false
  }

  constructor(
    private route: ActivatedRoute,
    private providerService: ProviderODataService,
    private entityGroupProviderService: EntityGroupProviderODataService
  ) {}

  availableCellStyle(data) {
    const style = {}

    if (!this.canSelect(data.value)) {
      style['color'] = 'silver'
    }

    return style
  }

  canSelect(provider: IProvider) {
    return this.selectedIds.indexOf(+provider.Id) === -1
  }

  getSelectedIds() {
    this.entityGroupProviderService
      .query()
      .select('ProviderId')
      .filter(`EntityGroupId eq ${this.entityGroupId}`)
      .exec()
      .subscribe(response => {
        this.selectedIds = response.data.map(x => +x.ProviderId)
        this.available.api.redrawRows()
      })
  }

  initializeAvailable() {
    this.available.gridOptions.context = this._gridOptions
    this.available.gridOptions.columnDefs = [
      {
        headerName: 'CHI Provider ID',
        field: 'Id',
        filter: 'agNumberColumnFilter',
        filterParams: { newRowsAction: 'keep' },
        cellRenderer: GridWrapperComponent.TooltipRenderer()
      },
      {
        headerName: 'Provider',
        field: 'Name',
        width: 200,
        cellRenderer: GridWrapperComponent.TooltipRenderer(),
        filter: 'agTextColumnFilter',
        filterParams: { newRowsAction: 'keep' },
        cellStyle: this.availableCellStyle.bind(this)
      },
      {
        headerName: 'NPI',
        field: 'Npi',
        width: 100,
        cellRenderer: GridWrapperComponent.TooltipRenderer(),
        filter: 'agTextColumnFilter',
        filterParams: { newRowsAction: 'keep', defaultOption: 'equals' },
        cellStyle: this.availableCellStyle.bind(this)
      }
    ]
    this.available.gridOptions.rowSelection = MultiRowSelection
    this.available.odata = this.providerService
    this.available.gridOptions.onSelectionChanged = this.recalculateSelected.bind(this)
  }

  initializeSelected() {
    this.selected.defaultFilter = `EntityGroupId eq ${this.entityGroupId}`
    this.selected.gridOptions.context = this._gridOptions
    this.selected.gridOptions.columnDefs = [
      {
        headerName: 'CHI Provider ID',
        field: 'ProviderId',
        filter: 'agNumberColumnFilter',
        filterParams: { newRowsAction: 'keep' },
        cellRenderer: GridWrapperComponent.TooltipRenderer()
      },
      {
        headerName: 'Provider',
        field: 'ProviderName',
        width: 200,
        cellRenderer: GridWrapperComponent.TooltipRenderer(),
        filter: 'agTextColumnFilter',
        filterParams: { newRowsAction: 'keep' }
      },
      {
        headerName: 'NPI',
        field: 'Npi',
        width: 100,
        cellRenderer: GridWrapperComponent.TooltipRenderer(),
        filter: 'agTextColumnFilter',
        filterParams: { newRowsAction: 'keep', defaultOption: 'equals' }
      }
    ]
    this.selected.gridOptions.rowSelection = MultiRowSelection
    this.selected.odata = this.entityGroupProviderService
    this.selected.gridOptions.onSelectionChanged = this.recalculateSelected.bind(this)
  }

  recalculateSelected() {
    this.availableSelection = this.available.api
      .getSelectedRows()
      .filter(this.canSelect.bind(this)) as IProvider[]

    this.selectedSelection = this.selected.api.getSelectedRows() as IEntityGroupProvider[]
  }
  select() {
    // TODO: Implement ODATA Batch
    const observables = this.availableSelection.map(item => {
      const model = {
        EntityGroupId: this.entityGroupId,
        ProviderId: item.Id,
        ProviderName: item.Name,
        Npi: item.Npi,
        TaxIdNumber: item.TaxIdNumber
      } as IEntityGroupProvider

      return this.entityGroupProviderService.post(model).exec()
    })

    forkJoin(observables).subscribe(results => {
      this.selected.getData()
      this.getSelectedIds()
      setTimeout(this.recalculateSelected.bind(this), 250)
    })
  }

  remove() {
    // TODO: Implement ODATA Batch
    const observables = this.selectedSelection.map(item =>
      this.entityGroupProviderService.delete(item.Id).exec()
    )

    forkJoin(observables).subscribe(results => {
      this.selected.getData()
      this.getSelectedIds()
      setTimeout(this.recalculateSelected.bind(this), 250)
    })
  }

  ngOnInit() {
    this.entityGroupId = +this.route.snapshot.params['id']

    this.initializeAvailable()
    this.initializeSelected()
    this.getSelectedIds()
  }
}
